/**
 * Different sub components, starts with `AttributeComponent:`
 */
export var AttributeComponentType;
(function (AttributeComponentType) {
    AttributeComponentType["AttributeHeadline"] = "AttributeComponent:AttributeHeadline";
    AttributeComponentType["AttributeDescription"] = "AttributeComponent:AttributeDescription";
    AttributeComponentType["AttributePropertyText"] = "AttributeComponent:AttributePropertyText";
    AttributeComponentType["AttributeInfoText"] = "AttributeComponent:AttributeInfoText";
})(AttributeComponentType || (AttributeComponentType = {}));
//# sourceMappingURL=AttributeComponentType.js.map